// @flow
import invariant from 'invariant';

// TODO: Resolve this
// eslint-disable-next-line import/no-cycle
import { darkenOrLighten, isDark } from './color';
import { colors } from '../ui/styles';
// import type { Styles } from '../ui/scramble4-connect';

type DerivedColor = $ReadOnly<{|
  brand_active: string,
  brand_hover: string,
  brand_text: string,
|}>;

type DerivedStyleParams = $ReadOnly<{|
  brand: string,
  darknessLine?: number,
  hoverAmount?: number,
  activeAmount?: number,
|}>;

const { white, black } = colors;
export const DEFAULT_DARKNESS_LINE = 106;
const DEFAULT_HOVER_AMOUNT = 0.08;
const DEFAULT_ACTIVE_AMOUNT = 0.16;

// this function exists purely to perfom side a side effect
const setStyle = (property: string, value: string, node: HTMLElement): void =>
  node.style.setProperty(property, value);

export const derivedColors = ({
  brand,
  darknessLine = DEFAULT_DARKNESS_LINE,
  hoverAmount = DEFAULT_HOVER_AMOUNT,
  activeAmount = DEFAULT_ACTIVE_AMOUNT,
}: DerivedStyleParams): DerivedColor => ({
  brand_active: darkenOrLighten(activeAmount, darknessLine)(brand),
  brand_hover: darkenOrLighten(hoverAmount, darknessLine)(brand),
  brand_text: isDark(brand, darknessLine) ? white : black,
});

// this function's effect is purely the generation of side effects
// namely setting CSS style variables for the brand's theme
export const setupClientTheme = ({
  brand,
  ...rest
}: DerivedStyleParams): void => {
  const root = document.documentElement;
  invariant(root, 'there should always be a root element');
  const {
    /* eslint-disable camelcase */
    brand_active,
    brand_hover,
    brand_text,
  } = derivedColors({ brand, ...rest });
  setStyle('--brand', brand, root);
  setStyle('--brand-hover', brand_hover, root);
  setStyle('--brand-active', brand_active, root);
  setStyle('--text-color', brand_text, root);
};
